import React, { useState } from 'react';
import copy from 'clipboard-copy';
import { useTranslation } from 'react-i18next';
import { CopyAdornment } from '../../../styles';
import { CopyContent } from '../styles';

type copyType = {
  value: string;
  label?: string;
  styles?: any;
};

const CopyInputBox = (props: copyType) => {
  const { styles = {} } = props;
  const { t } = useTranslation();
  const [isCopyClicked, setIsCopyClicked] = useState<boolean>(false);

  const onCopyClick = (copiedData: string) => {
    copy(copiedData);
    setIsCopyClicked(true);
    setTimeout(() => {
      setIsCopyClicked(false);
    }, 1500);
  };
  return (
    <CopyContent {...styles}>
      {props.label ? <div className="copy-label">{props.label}</div> : null}
      <div className="copy-box">
        <div className="copy-box-text">{props.value}</div>
        <CopyAdornment onClick={() => onCopyClick(props.value)}>
          {isCopyClicked ? t('copied') : t('copy')}
        </CopyAdornment>
      </div>
    </CopyContent>
  );
};

export default CopyInputBox;
